import React from "react";
import { useTranslation } from "react-i18next";
import { KYC_STEPS } from "../flow/kycSteps";

const PHASES = [
  {
    key: "document",
    steps: [
      KYC_STEPS.DOCUMENT_TYPE,
      KYC_STEPS.DOCUMENT_PREPARATION,
      KYC_STEPS.DOCUMENT_CAPTURE,
      KYC_STEPS.DOCUMENT_REVIEW,
      KYC_STEPS.DOCUMENT_BACK_PREPARATION,
    ],
  },
  {
    key: "face",
    steps: [KYC_STEPS.SELFIE, KYC_STEPS.LIVENESS],
  },
  {
    key: "addressProof",
    steps: [KYC_STEPS.ADDRESS_PROOF_PREPARATION, KYC_STEPS.ADDRESS_PROOF],
  },
];

const COMPLETED_FLOW_STEPS = new Set([
  KYC_STEPS.FINAL_REVIEW,
  KYC_STEPS.SUBMITTING,
  KYC_STEPS.PROCESSING,
  KYC_STEPS.SUCCESS,
  KYC_STEPS.FAILED,
  KYC_STEPS.RETRY,
]);

export function ProgressIndicator({ currentStep }) {
  const { t } = useTranslation();
  const matchedPhase = PHASES.findIndex((phase) =>
    phase.steps.includes(currentStep),
  );
  const phaseIndex = COMPLETED_FLOW_STEPS.has(currentStep)
    ? PHASES.length
    : Math.max(0, matchedPhase);
  const visiblePhaseIndex = Math.min(phaseIndex, PHASES.length - 1);
  const progress = Math.round(
    (Math.min(phaseIndex + 1, PHASES.length) / PHASES.length) * 100,
  );
  const currentPhase = PHASES[visiblePhaseIndex];

  return (
    <div className="kyc-progress-indicator w-full">
      <div className="kyc-progress-heading mb-2 flex items-center justify-between gap-4">
        <span className="truncate text-sm font-semibold text-slate-800">
          {t(`kyc.flow.phases.${currentPhase.key}`)}
        </span>
        <span className="shrink-0 text-xs font-medium tabular-nums text-slate-500">
          {visiblePhaseIndex + 1} / {PHASES.length}
        </span>
      </div>
      <div
        className="h-1.5 overflow-hidden rounded-full bg-slate-200"
        role="progressbar"
        aria-label={t("kyc.portal.progressLabel")}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={progress}
      >
        <span
          className="block h-full rounded-full bg-teal-600 transition-[width] duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
